import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Sets the browser tab title (document.title) for the whole app from the
 * "Browser Tab Title" configured in Settings → Online Storefront (stored as
 * the storefront `seo_title`). Falls back to the static index.html title.
 * Renders nothing.
 */
const DocumentTitle = () => {
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/storefront/site-title`)
      .then((res) => {
        const t = (res.data?.site_title || '').trim();
        if (!cancelled && t) document.title = t;
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return null;
};

export default DocumentTitle;
